import React, { useState, useEffect } from 'react';
import { API_BASE } from "../config";

export default function StatsNotaire({ emailNotaire }) {
  //console.log("stats notaire", emailNotaire)
  const [counts, setCounts] = useState({ demandesCount: 0, questionsCount: 0, appelsCount: 0, total: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!emailNotaire) return;

    //http://localhost:5050/api/getAnalyticsForNotaire?notaireEmail=${emailNotaire}
    //https://cloterenotaire.onrender.com/api/getAnalyticsForNotaire?notaireEmail=${emailNotaire}
    async function fetchAnalytics() {
      try {
        const res = await fetch(`${API_BASE}/api/getAnalyticsForNotaire?notaireEmail=${emailNotaire}`);
        const data = await res.json();

        if (data.OK) {
          setCounts({
            demandesCount: data.demandesCount,
            questionsCount: data.questionsCount,
            appelsCount: data.questionsCount,
            total: data.total,
          });
        } else {
          console.warn("Erreur API:", data.message);
        }
      } catch (e) {
        console.error("Erreur fetch analytics:", e);
      } finally {
        setLoading(false);
      }
    }

    fetchAnalytics();
  }, [emailNotaire]);

  if (loading) return <p>Chargement...</p>;

  return (
    <>
      <div className='mt-3  flex flex-col sm:flex-row gap-3 w-full justify-between'>
        

         {/** card rdv  */}
        <div className="flex w-full flex-1 justify-between gap-x-16 gap-y-8 rounded-2xl bg-indigo-700 p-8 ">
          <div className="sm:w-80 sm:shrink lg:w-auto lg:flex-none">
            <p className="text-lg font-semibold tracking-tight text-white !word-break">
              Demandes de rendez-vous
            </p>
            <p className="flex-none text-3xl font-bold tracking-tight text-white">{counts.demandesCount}</p>
            <p className="mt-2 text-xs text-gray-400 dark:text-gray-300 mb-0">
              Depuis la création de votre compte
            </p>
          </div>
        </div>

         {/** card question  */}
        <div className="flex w-full flex-1 justify-between gap-x-16 gap-y-8 rounded-2xl bg-indigo-500 p-8 ">
          <div className="sm:w-80 sm:shrink lg:w-auto lg:flex-none">
            <p className="text-lg font-semibold tracking-tight text-white">
              Questions reçues
            </p>
            <p className="flex-none text-3xl font-bold tracking-tight text-white">{counts.questionsCount}</p>
            <p className="mt-2 text-xs text-gray-400 dark:text-gray-300 mb-0">
              Depuis la création de votre compte
            </p>
          </div>
        </div>

      </div>
    </>
  );
}

